import { mockComponent } from 'bloko/common/setupMockComponents';

const { NotificationKind } = jest.requireActual('bloko/blocks/notificationManager/Notification.js');

export { NotificationKind };
export default mockComponent('Notification', null, { withChildren: true });
